module.exports = __webpack_public_path__ + "static/media/solo-nationals@2x.c91bdfe9.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/solo-nationals@2x.png
// module id = 1166
// module chunks = 0